module.exports = __webpack_public_path__ + "static/polhora-invest-grey-8289fbab3795b544db7aeee2473f7328.png";